module.exports = require('lodash').pickBy